"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var inertia_react_1 = require("@inertiajs/inertia-react");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var react_i18next_1 = require("react-i18next");
var material_1 = require("@mui/material");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var react_admin_1 = require("react-admin");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var CreateOAuth2ClientModal = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(""), tokenName = _a[0], setTokenName = _a[1];
    var _b = (0, react_1.useState)(""), clientId = _b[0], setClientId = _b[1];
    var _c = (0, react_1.useState)(""), clientSecret = _c[0], setClientSecret = _c[1];
    var _d = (0, react_1.useState)(true), scheduleActive = _d[0], setScheduleActive = _d[1];
    var _e = (0, react_1.useState)(false), alertOpen = _e[0], setAlertOpen = _e[1];
    var _f = (0, react_1.useState)(""), alertMessage = _f[0], setAlertMessage = _f[1];
    var refresh = (0, react_admin_1.useRefresh)();
    var logger = q_play_core_1.logManager.getLogger();
    var createOAuthClientForm = (0, inertia_react_1.useForm)({
        name: "",
        client_id: "",
        client_secret: "",
        active: true,
    });
    var generateRandomString = function (length) {
        var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var result = "";
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    };
    (0, react_1.useEffect)(function () {
        if (props.isShown) {
            if (props.mode === "edit" && props.oAuth2Token) {
                setTokenName(props.oAuth2Token.name);
                setClientId(props.oAuth2Token.client_id);
                setClientSecret(props.oAuth2Token.client_secret);
                setScheduleActive(props.oAuth2Token.active);
            }
            else {
                var generatedClientId = generateRandomString(20 + Math.floor(Math.random() * 13));
                var generatedClientSecret = generateRandomString(20 + Math.floor(Math.random() * 13));
                setClientId(generatedClientId);
                setClientSecret(generatedClientSecret);
                setScheduleActive(true);
                setTokenName("");
            }
            createOAuthClientForm.setData("client_id", clientId);
            createOAuthClientForm.setData("client_secret", clientSecret);
            createOAuthClientForm.setData("active", scheduleActive);
        }
    }, [props.isShown]);
    var toggleSchedule = function (event) {
        setScheduleActive(event.target.checked);
        createOAuthClientForm.setData("active", event.target.checked);
    };
    var handleSaveClient = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(props.mode === "new")) return [3 /*break*/, 2];
                    return [4 /*yield*/, createClient()];
                case 1:
                    _a.sent();
                    refresh();
                    return [3 /*break*/, 4];
                case 2:
                    if (!(props.mode === "edit" && props.oAuth2Token)) return [3 /*break*/, 4];
                    return [4 /*yield*/, updateClient(props.oAuth2Token.id)];
                case 3:
                    _a.sent();
                    refresh();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var createClient = function () { return __awaiter(void 0, void 0, void 0, function () {
        var postData, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    postData = {
                        name: tokenName,
                        client_id: clientId,
                        client_secret: clientSecret,
                        active: scheduleActive
                    };
                    return [4 /*yield*/, ApiManager_1.default.addOAuth2Client(postData.name, postData.client_id, postData.client_secret, postData.active)];
                case 1:
                    response = _a.sent();
                    if (response.data.errors && response.status === 422) {
                        logger.error("Validation errors: ", response.data.errors);
                    }
                    else {
                        props.toggle();
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error creating OAuth2 client: ", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateClient = function (clientId) { return __awaiter(void 0, void 0, void 0, function () {
        var postData, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    postData = {
                        name: tokenName,
                        active: scheduleActive
                    };
                    return [4 /*yield*/, ApiManager_1.default.updateOAuth2Client(clientId, postData)];
                case 1:
                    response = _a.sent();
                    if (response.data.errors && response.status === 422) {
                        logger.error("Validation errors: ", response.data.errors);
                    }
                    else {
                        props.toggle();
                        refresh();
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    logger.error("Error updating OAuth2 client: ", error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleCopyToClipboard = function (text, message) {
        navigator.clipboard.writeText(text).then(function () {
            setAlertMessage(message);
            setAlertOpen(true);
        });
    };
    var handleAlertClose = function () {
        setAlertOpen(false);
    };
    var body = (react_1.default.createElement("div", { className: "d-flex flex-column", "data-cy": "createOAuth2ClientModal" },
        react_1.default.createElement("div", { className: "mt-4" },
            react_1.default.createElement("label", { htmlFor: "name" }, t("Name")),
            react_1.default.createElement(q_play_components_1.Input, { id: "token_name", className: "mt-1 block w-full", value: tokenName, onChange: function (event) {
                    setTokenName(event.target.value);
                    createOAuthClientForm.setData("name", event.target.value);
                }, required: true, "data-cy": "clientNameInput" })),
        react_1.default.createElement("div", { className: "mt-4" },
            react_1.default.createElement("label", { htmlFor: "client_id" }, t("Client ID")),
            react_1.default.createElement(q_play_components_1.Input, { id: "client_id", className: "mt-1 block w-full", value: clientId, readOnly: true, onClick: function () { return handleCopyToClipboard(clientId, t("Client id copied")); }, style: { backgroundColor: "rgb(224, 225, 226)", cursor: "pointer" }, "data-cy": "clientIdInput" })),
        react_1.default.createElement("div", { className: "mt-4" },
            react_1.default.createElement("label", { htmlFor: "client_secret" }, t("Client Secret")),
            react_1.default.createElement(q_play_components_1.Input, { id: "client_secret", className: "mt-1 block w-full", value: clientSecret, readOnly: true, onClick: function () { return handleCopyToClipboard(clientSecret, t("Client secret copied")); }, style: { backgroundColor: "rgb(224, 225, 226)", cursor: "pointer" }, "data-cy": "clientSecretInput" })),
        react_1.default.createElement("div", { className: "mt-4", style: { display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" } },
            react_1.default.createElement("label", { htmlFor: "active_switch" }, t("Active")),
            react_1.default.createElement(q_play_components_1.Switch, { id: "active_switch", checked: scheduleActive, onChange: toggleSchedule, "data-cy": "activeSwitch" }))));
    var footer = (react_1.default.createElement("div", { className: "d-flex flex-fill justify-content-center", style: { marginTop: "1rem" } },
        react_1.default.createElement(q_play_components_1.Button, { onClick: handleSaveClient, variant: "primary", text: t(props.mode === "new" ? "Create" : "Update"), size: "small", className: "w-75", dataCy: "createClientButton" })));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, onClose: props.toggle, centered: true, headerText: t(props.mode === "new" ? "Create OAuth2 Client" : "Update OAuth2 Client"), body: body, footer: footer }),
        react_1.default.createElement(material_1.Snackbar, { open: alertOpen, autoHideDuration: null, onClose: handleAlertClose, anchorOrigin: { vertical: "bottom", horizontal: "center" } },
            react_1.default.createElement(material_1.Alert, { onClose: handleAlertClose, severity: "success", iconMapping: { success: null }, sx: {
                    width: "100%",
                    backgroundColor: "var(--secondary-color)",
                    color: "var(--info-color)",
                    fontFamily: "Geomanist",
                    borderRadius: "10px",
                    "& .MuiSvgIcon-root": {
                        marginTop: "-1px",
                    }
                }, "data-cy": "alertMessage" }, alertMessage))));
};
exports.default = CreateOAuth2ClientModal;
